export default __webpack_public_path__ + "static/1952-61145c82e872d772f1498e0fe320981f.gif";